// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1031":"1197accb","2959":"7551eb2b","6664":"7551eb2b"}[chunkId] + ".chunk.css";
};